export default "__VITE_ASSET__mSPM5A$H__"